<template>
  <div class="store-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "storeBase",
};
</script>
